module.exports = __webpack_public_path__ + "static/img/Blaize-Talagi.ba6f53e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blaize-Talagi.jpg
// module id = ek7o
// module chunks = 0